import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SkeletonLoader } from '@frontend/design-system';

type FaxItemSkeletonLoaderProps = {
  repeat?: number;
};

export const FaxItemSkeletonLoader = ({ repeat = 1 }: FaxItemSkeletonLoaderProps) => {
  return (
    <>
      {Array.from({ length: repeat }).map((_, index) => (
        <div
          key={`fax-skeleton-${index}`}
          css={css`
            display: block;
            border: 1px solid ${theme.colors.neutral10};
            border-radius: ${theme.borderRadius.small};
            padding: ${theme.spacing(2)};
            min-width: 234px;
            flex: 1;
            background-color: ${theme.colors.white};
          `}
        >
          <div
            css={css`
              width: 100%;
              display: flex;
              align-items: center;
              gap: ${theme.spacing(2)};
            `}
          >
            <SkeletonLoader
              css={css`
                flex-shrink: 0;
              `}
              shape='circle'
              width={40}
              height={40}
            />
            <div
              css={css`
                overflow: hidden;
                width: 100%;
              `}
            >
              <div
                css={css`
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  min-width: 0;
                  gap: ${theme.spacing(1)};
                  margin-bottom: ${theme.spacing(1)};
                `}
              >
                <SkeletonLoader width={12} height={12} shape='circle' />
                <SkeletonLoader height={16} width='60%' />
              </div>
              <SkeletonLoader
                css={css`
                  margin-bottom: ${theme.spacing(0.5)};
                `}
                width='45%'
                height={14}
              />
              <SkeletonLoader width='35%' height={14} />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
